// src/components/Section.js
import React from "react";
import greenWorld from "./assets/images/green world-wide.jpg";
import farmer from "./assets/images/farmer_11zon.webp";
import gestion from "./assets/images/gestion.jpg";
import transport from "./assets/images/transport.jpg"

const Section = () => {
  return (
<div className="p-4 py-10 bg-gradient-to-b from-[#9ec083] to-[#69B578]">
  <div className="container mx-auto">
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 text-center text-white">
      <div className="p-4 bg-[#69B578] rounded-lg shadow-md">
        <img
          src={greenWorld}
          alt="I1"
          className="w-full h-40 object-cover mb-4 rounded-lg"
        />
        <h3 className="text-xl font-semibold mb-2">
          Élargissez votre marché
        </h3>
        <p>
          Nous simplifions l'exportation de vos produits périssables, en
          garantissant fraîcheur et qualité supérieure.
        </p>
      </div>
      <div className="p-4 bg-[#69B578] rounded-lg shadow-md">
        <img
          src={gestion}
          alt="1"
          className="w-full h-40 object-cover mb-4 rounded-lg"
        />
        <h3 className="text-xl font-semibold mb-2">Gestion</h3>
        <p>
          Nous veillons à ce que vos fruits, légumes et produits du terroir
          arrivent à destination dans des conditions optimales.
        </p>
      </div>
      <div className="p-4 bg-[#69B578] rounded-lg shadow-md">
        <img
          src={farmer}
          alt="1"
          className="w-full h-40 object-cover mb-4 rounded-lg"
        />
        <h3 className="text-xl font-semibold mb-2">
          Expérience et passion
        </h3>
        <p>
          Portés par une expertise locale et une passion pour répondre aux
          exigences du marché d'exportation mondial.
        </p>
      </div>
      <div className="p-4 bg-[#69B578] rounded-lg shadow-md">
        <img
          src={transport}
          alt="1"
          className="w-full h-40 object-cover mb-4 rounded-lg"
        />
        <h3 className="text-xl font-semibold mb-2">
          Solutions d'exportation
        </h3>
        <p>
          Nous travaillons en étroite collaboration avec vous pour fournir
          des solutions d'exportation adaptées.
        </p>
      </div>
    </div>
  </div>
</div>

  );
};

export default Section;